// extracted by mini-css-extract-plugin
module.exports = {"commentRow":"OrderEditDetails_commentRow__3cK1B"};